
<!--
<app-text-window
  [title]="'Ważny komunikat dla Państwa'"
  [content]="'Wkrótce otwarcie, zapraszamy do zapoznania się ze szczegółami!'">
</app-text-window>
-->

<div class="info-container">
GABINET WETERYNARYJNY WALDEMAR GRZECHNIK*
<br>
RYNEK 4, 32-031 MOGILANY
<br>
<h1>JUŻ OTWARTE!</h1>

PLANOWANE GODZINY DZIAŁALNOŚCI:
<br>

<b>PN - PT</b> 16:00-20:00
<br>
<b>SOBOTA</b> 09:00- 14:00
<br>

TELEFON KONTAKTOWY:
<br>
537 151 280
<br>
<br>
<br>
* FILIA GABINETU W ŚWIĄTNIKACH GÓRNYCH
<br>

TEL. 664 524 364
<br>
</div>
